import { Grid } from "@mui/material";
import useStyles from "../../inventory/styles";
import Button from "../../../components/Button";
import { useState, useEffect } from "react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
// import { useTruncate } from "../../hooks/useTruncate";
import useValidator from "../../../hooks/useValidator";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../../components/Modal";
import { InventoryCondition } from "../../../utils/DropDown";

const INVENTORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory/";
const INVENTORY_CATEGORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory/";
const EMPLOYEES_ENDPOINT = "/api/v1/employees";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const CreateInventory = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [inventoryCategory, setInventoryCategory] = useState([]);
  const [inventoryValidator, showInventoryValidator] = useValidator();
  const [selectedFile, setSelectedFile] = useState([]);
  const [employeeData, setEmployeesData] = useState([]);

  const [inventoryForm, setInventoryForm] = useState({
    name: "",
    category: "",
    employee_in_charge: "",
    quantity: "",
    condition: ""
  });
  const getAllInventoryCategory = () => {
    httprequest.get(`${INVENTORY_CATEGORY_ENDPOINT}${id}/categories`).then((res) => {
      setInventoryCategory(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleCancelModal = () => {
    setCancelModal(!cancelModal);
  };

  // FOR FILE UPLOAD
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const filesArray = Array.from(e.target.files);
      setSelectedFile(filesArray);
    }
  };

  const getAllEmployees = () => {
    httprequest.get(EMPLOYEES_ENDPOINT).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleRemoveFile = (indexToRemove) => {
    const filtered = selectedFile.filter((_, i) => i !== indexToRemove);
    setSelectedFile(filtered);
  };

  const handleCreateInventory = async () => {
    if (!inventoryValidator.allValid()) {
      showInventoryValidator(true);

      return;
    }
    setIsLoading(true);
    try {
      let uploadData = {};
      // Handle file upload if there's a selected file
      if (selectedFile?.length > 0) {
        const formData = new FormData();

        selectedFile.forEach((file) => {
          formData.append("file", file);
        });

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response?.status === 200 && response?.data?.data) {
          const uploadedImages = response?.data?.data.map((file) => ({
            upload_id: file?.upload_id,
            file_url: file?.file_url
          }));
          uploadData = { images: uploadedImages };
        }
      }
      // ready final data object for post
      const data = { ...inventoryForm, ...uploadData };
      const createInventoryResponse = await httprequest.post(`${INVENTORY_ENDPOINT}${id}/inventory`, data);
      setIsLoading(false);
      toast.success(createInventoryResponse?.data?.message);
      setInventoryForm({ ...inventoryForm, name: "", category: "", employee_in_charge: "", quantity: "", condition: "" });
      setSelectedFile("");
      setTimeout(() => {
        navigate(`/hostel/${id}`);
      }, 3000);
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInventoryForm({ ...inventoryForm, [name]: value });
  };

  useEffect(() => {
    getAllInventoryCategory();
    getAllEmployees();
  }, []);

  const { name, category, employee_in_charge, quantity, condition } = inventoryForm;

  return (
    <div>
      <div>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <InputGroup
              label="Product Name"
              margin="normal"
              required
              placeHolder="Enter product name"
              inputType="text"
              inputName="name"
              value={name}
              onChange={handleChange}
            />
            {inventoryValidator.message("Product Name", name, "required")}
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectGroup required label="Category" children={
              <select onChange={handleChange} value={category} name="category">
                <option value="">--- Select ---</option>
                {inventoryCategory?.map((data) => {
                  return (
                    <option key={data?.id} value={data?.id}>{data?.category}</option>
                  );
                })}
              </select>
            }
            />
            {inventoryValidator.message("Category", category, "required")}
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <InputGroup
              label="Quantity"
              margin="normal"
              required
              placeHolder=""
              inputType="number"
              inputName="quantity"
              value={quantity}
              onChange={handleChange}
            />
            {inventoryValidator.message("Quantity", quantity, "required")}
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <SelectGroup required label="Condition" children={
              <select name="condition" onChange={handleChange} value={condition}>
                <option value="">--- Select ---</option>
                {InventoryCondition?.map((conditions) => {
                  return (
                    <option key={conditions?.key} value={conditions?.key}>{conditions?.text}</option>
                  );
                })}
              </select>
            }
            />
            {inventoryValidator.message("Condition", condition, "required")}
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectGroup required label="Employee in Charge" children={
              <select onChange={handleChange} name="employee_in_charge">
                <option value="">--- Select ---</option>
                {employeeData?.map((employee) => {
                  return (
                    <option key={employee?.employee_id} value={employee?.employee_id}>{employee?.first_name}{" "}{employee?.last_name}</option>
                  );
                })}
              </select>
            }
            />
            {inventoryValidator.message("Employee", employee_in_charge, "required")}
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className={classes.fordesc}>
              <p>Description</p>
            </div>
            <div className={classes.textandimg}>
              <textarea
                type="text"
                placeholder="description"
                name="description"
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <div className={classes.fordesc}>
              <p>Add Image</p>
            </div>

            <div className={classes.pickercontainer}>
              <input
                type="file"
                multiple
                className={classes.picker}
                onChange={handleFileChange}
                name="file"
                accept="image/jpeg,image/jpe,image/png"
              />

              <div className={classes.uploadflex}>
                <div>
                  <Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} />
                </div>

                {selectedFile?.length > 0 ? (
                  <div>
                    <p className={classes.uploadtitle}>Images Added</p>
                    <p className={classes.uploadsubtitle}>
                      {selectedFile.length} file{selectedFile.length > 1 ? "s" : ""} selected
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className={classes.uploadtitle}>Tap to Upload</p>
                    <p className={classes.uploadsubtitle}>SVG, PNG, JPG | 10MB max.</p>
                  </div>
                )}
              </div>
            </div>
          </Grid>
          {selectedFile?.length > 0 && (
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <div className={classes.previewGrid}>
                {selectedFile.map((file, index) => {
                  const fileUrl = URL.createObjectURL(file);

                  return (
                    <div key={index} className={classes.previewItem}>
                      <img src={fileUrl} alt={`preview-${index}`} className={classes.previewImage} />
                      <div
                        className={classes.removeBtn}
                        onClick={() => handleRemoveFile(index)}
                      >
                        <Icon icon="zondicons:minus-solid" /> Remove
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          )}
        </Grid>
        <div className="flex gap-10">
          <Button variant="primaryoutline" buttonSize="medium" color="btnfontprimary" buttonName="Cancel" onClick={handleCancelModal} />
          <Button variant="primary" buttonSize="medium" color="btndefault" buttonName="Create Inventory" onClick={handleCreateInventory} isLoading={isLoading} />
        </div>
      </div>
      {/* Cancel Modal */}
      <Modal
        title="Cancel Create Inventory"
        subtitle={
          <div>Are you sure you want to cancel, cancelling will not save any changes made to creating this inventory.
          </div>}
        modalContent={
          <>
          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Cancel Create Inventory" buttonSize="full" color="btndefault" onClick={() => {
              navigate(`/hostel/${id}`);
            }}
            />
          </>
        }
        isopen={cancelModal}
        closeModal={handleCancelModal}
      />
      {/* <ToastContainer /> */}
    </div>
  );
};

export default CreateInventory;
